import { AppRoutesUI } from "./appRoutes";
import {
  SvgAdmin,
  SvgBlackList,
  SvgList,
  SvgPlus,
  SvgSuperAdmin,
  SvgUsers,
  SvgUserLog,
} from "../assets/icons/index";

export const navLinks: {
  [key: string]: {
    path: string;
    icon?: React.FunctionComponent<
      React.SVGProps<SVGSVGElement> & {
        title?: string | undefined;
      }
    >;
    activeOnPaths?: string[];
  };
} = {
  superAdmin: {
    path: "#",
    icon: SvgSuperAdmin,
    activeOnPaths: [
      AppRoutesUI.SuperAdmin.SuperAdminList(),
      AppRoutesUI.SuperAdmin.SuperAdminCreate(),
    ],
  },
  blackListEmail: {
    path: "#",
    icon: SvgBlackList,
    activeOnPaths: [
      AppRoutesUI.BlackListEmail.EmailList(),
      AppRoutesUI.BlackListEmail.EmailAdd(),
    ],
  },
  admins: {
    path: "#",
    icon: SvgAdmin,
    activeOnPaths: [
      AppRoutesUI.Admins.AdminList(),
      AppRoutesUI.Admins.AdminAdd(),
    ],
  },
  users: {
    path: "#",
    icon: SvgUsers,
    activeOnPaths: [
      AppRoutesUI.Users.UsersList(),
      AppRoutesUI.Users.UsersAdd(),
    ],
  },
  userLog: {
    path: AppRoutesUI.UserLog.Root(),
    icon: SvgUserLog,
  },
  superAdminList: {
    path: AppRoutesUI.SuperAdmin.SuperAdminList(),
    icon: SvgList,
  },
  superAdminCreate: {
    path: AppRoutesUI.SuperAdmin.SuperAdminCreate(),
    icon: SvgPlus,
  },
  blackListEmailList: {
    path: AppRoutesUI.BlackListEmail.EmailList(),
    icon: SvgList,
  },
  blackListEmailCreate: {
    path: AppRoutesUI.BlackListEmail.EmailAdd(),
    icon: SvgPlus,
  },
  adminsList: {
    path: AppRoutesUI.Admins.AdminList(),
    icon: SvgList,
  },
  adminsCreate: {
    path: AppRoutesUI.Admins.AdminAdd(),
    icon: SvgPlus,
  },
  usersList: {
    path: AppRoutesUI.Users.UsersList(),
    icon: SvgList,
  },
  usersCreate: {
    path: AppRoutesUI.Users.UsersAdd(),
    icon: SvgPlus,
  },
};
